import React from "react";

import {moveToTop} from "../helpers/utils";
import {RotatingLines} from "react-loader-spinner";
import PageHeader from "../common/PageHeader";
import { Link } from "react-router-dom";
import Processes from "../Processes";
import processListVendorManagement from "../processesDir/processListVendorManagement";
export default function VendorManagement() {
  const [loader, setLoader] = React.useState(false);
  console.log(setLoader);

  React.useEffect(() => {
    moveToTop();
  }, []);

  if (loader)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{minHeight: "100vh"}}
      >
        <RotatingLines
          strokeColor="grey"
          strokeWidth="5"
          animationDuration="0.75"
          width="96"
          visible={true}
        />
      </div>
    );
  return (
    <div className="container" style={{'marginTop':'80px'}}>
      <PageHeader
        // preTitle="About Condozak"
        title="Vendor Management"
        description="Manage vendors and service providers more efficiently with CONDOZAK™ Vendor Management."
        className="mb-3"
        titleTag="h2"
      >
        <Link className="btn btn-sm btn-link ps-0" to="/contact-us">
          Have questions? Chat with us
        </Link>
      </PageHeader>
      {/* <ProcessesAbout /> */}
      <Processes processList={processListVendorManagement} headerDisable/>
    </div>
  );
}
